import React from 'react';
import Warning from "../../warning";
import Verbiage from '../../verbiage.js';

function ExceededQuantityWarning({
    ffm,
    fulfillmentDetails
}){

    const getInStoreMessage = (quantity)=>{
        return(
            <Warning>
                <span className='dai_warning_exceeded_quantity'>Your store has only&nbsp;
                  <span className='u__bold'>{quantity}</span>
                  &nbsp;in stock. Please reduce the quantity, check nearby pickup stores, or change your fulfillment to proceed.
                </span>          
            </Warning>
        );
    }

    const getOnlineMessage = (quantity)=>{
        return(
            <Warning>
                <span className='dai_warning_exceeded_quantity'>Only <span className='u__bold'>{quantity}</span> in stock. Please reduce the quantity or change your fulfillment to proceed.</span>
            </Warning>
        );
    }

    if(ffm==="PICKUP"){
        if(fulfillmentDetails.pickupType==="BOPIS"){
            return getInStoreMessage(fulfillmentDetails.storeQuantity||fulfillmentDetails.nearbyStoreQuantity);
        }else if(fulfillmentDetails.pickupType==="BOSS"){
            return getOnlineMessage(fulfillmentDetails.onlineQuantity);
        }
        
    }else if(ffm==="STH"){
        return getOnlineMessage(fulfillmentDetails.onlineQuantity);
    }else if(ffm==="EXPRESS"){
        return getInStoreMessage(fulfillmentDetails.storeQuantity);
    }else{
        return null;
    }
}
export default ExceededQuantityWarning;
